import { defineComponent, h, useAttrs } from 'vue'

export default defineComponent({
  name: 'VStepperStepCompat',
  compatConfig: {
    RENDER_FUNCTION: false,
    COMPONENT_V_MODEL: false,
    INSTANCE_ATTRS_CLASS_STYLE: false
  },
  inheritAttrs: false,

  props: {
    complete: {
      type: Boolean,
      default: false
    }
  },

  setup(props, { slots }) {
    const attrs = useAttrs()

    return () =>
      h(
        'div',
        {
          ...attrs,
          class: [
            'v-stepper__step',
            {
              'v-stepper__step--complete': props.complete
            },
            attrs.class
          ]
        },
        [
          h('span', { class: 'v-stepper__step__step' }, [
            props.complete
              ? h('i', {
                  class: ['v-icon', 'notranslate', 'mdi', 'mdi-check'],
                  'aria-hidden': 'true',
                  role: 'img'
                })
              : null
          ]),
          h(
            'div',
            {
              class: 'v-stepper__label'
            },
            slots.default?.()
          )
        ]
      )
  }
})
